import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';

//Services
import { ErrorhandlerService } from './errorhandler.service';
import { ProfileService } from './profile.service';
//import { ContentManagementService } from './content-management.service';


//Environment
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailManagementService {
	private apiUrl = environment.apiUrl; 
	public adminEmailsObj: BehaviorSubject<any>= new BehaviorSubject<any>([]);
	public adminEmailObj: BehaviorSubject<any>= new BehaviorSubject<any>([]);
	public adminNotificationsObj: BehaviorSubject<any>= new BehaviorSubject<any>([]);
	public adminNotificationObj: BehaviorSubject<any>= new BehaviorSubject<any>([]);
	public adminCTAsObj: BehaviorSubject<any>= new BehaviorSubject<any>([]);
	create_email_template_admin = false;
	original_template="";
	current_template_id=null;
	routerurl='/email-management';
	public email_preview: any |[];
	create_notification_admin = false;
	current_notification_id=null;
	showNotes=false;

  constructor( private http: HttpClient,
	 private cookie: CookieService,
	 private location: Location,
	 private router: Router,
	// private CMS : ContentManagementService,
	 private PS : ProfileService,
	 private errorhandlerService: ErrorhandlerService){ 
  
  }
	
/* ------------------------------------------------------------ *\
	API CALLS
\* ------------------------------------------------------------ */

	pullAdminEmails():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'emailtemplates')
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	
	pullMailStats():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'mailstats')
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	pullMailStatsById(id):Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'mailstats/'+id)
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	
	pullAdminEmail(id):Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'emailtemplate/'+id)
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	
	pullReuseTemplate(id):Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'reusetemplate/'+id)
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	pullSentPreview(id):Observable<any>{
		
    	return this.http.get<any[]>(this.apiUrl + 'previewemail/'+id)
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	pullAdminNotifications():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'featuredforadmin')
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	
	pullAdminNotification(id):Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'featuredforadmin/'+id)
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	pullNoteCTAs():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'featuredcta')
      .pipe(
        catchError(this.errorhandlerService.handleError())
      );
	}
	
	
	updateMailStats(){
		//call api
		//set next
		alert('in progress');
	}
	processMailStats(){
		this.pullMailStats().subscribe((response) => {
			 console.log('response', response);
		});
		this.getEmailTemplates().subscribe((response) => {
			 console.log('response', response);
		});
	}
	
	
	adminSaveEmailTemplate( json_data){
		return this.http.post<any[]>(this.apiUrl + 'emailtemplate', json_data).pipe(
		catchError(this.errorhandlerService.handleError())
		);
	}
	adminSendTestEmail(id, json_data){
		return this.http.put<any[]>(this.apiUrl + 'sendtest', json_data).pipe(
		catchError(this.errorhandlerService.handleError())
		);
	}
	adminSendEmails(id, json_data){
		return this.http.post<any[]>(this.apiUrl + 'launcheblast', json_data).pipe(
		catchError(this.errorhandlerService.handleError())
		);
	}
	adminSaveNotification( json_data){
		return this.http.put<any[]>(this.apiUrl + 'featured', json_data).pipe(
		catchError(this.errorhandlerService.handleError())
		);
	}
        

	
/* ------------------------------------------------------------ *\
	FEED COMPONENTS
\* ------------------------------------------------------------ */
	
	getEmailTemplates(){
		var prtemp=this.processAdminEmails();
		console.log('adminEmailsObj', this.adminEmailsObj);
		return this.adminEmailsObj;
	}
	getEmailTemplate(id){
		var prtemp=this.processAdminEmail(id);
		console.log('adminEmailObj', this.adminEmailsObj);
		return this.adminEmailObj;
	}
	
  //Angular gets the accounts for the admin
	processAdminEmails(){
		this.pullAdminEmails().subscribe((response) => {
			 this.adminEmailsObj.next(response);
			 console.log('response', response);
		});
	}
	processAdminEmail(id){
		this.pullAdminEmail(id).subscribe((response) => {
			 var temp=response;
			console.log('templateresponse', response)
			 this.adminEmailObj.next(temp);
		});
	}
	
	reuse_existing_template(id,adhoc){
		this.pullReuseTemplate(id).subscribe((response) => {
			 //var temp=response;
			 console.log(response);
			if(adhoc==1){
				this.router.navigate(['/admin/email-detail/'+response]);
			}else{
				this.router.navigate(['/admin/email-newsletter-detail/'+response]);
			}
		});
	}
	adminGetSentPreview(id){
		this.pullSentPreview(id).subscribe((response) => {
			 //var temp=response;
			 console.log(response);
			this.email_preview="<!DOCTYPE html PUBLIC '-//W3C//DTD XHTML 1.0 Transitional//EN' 'http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd'><html xmlns='http://www.w3.org/1999/xhtml'><head>	<title></title>	<meta http-equiv='Content-Type' content='text/html; charset=utf-8'></meta>	<style type='text/css'>	/* ALL STYLES ARE ALSO INSERTED INLINE */.body{		font-family: Arial, Helvetica, sans-serif;		font-size: 18px;		color: #000000;		letter-spacing: 0.5px;		line-height: 30px;	}	.h1{		font-size: 40px;		line-height: 45px;		color:#72317D;	}	.headline{  color:#72317D;	  font-weight: bold;	}	.emphasis{		font-weight: bold;		color:#72317D;		border-bottom-color:#F5C750;		border-bottom-width:2px;		border-bottom-style:solid;		border-bottom: 2px solid #F5C750;	}	.contactcopy{		font-size: 14px;	line-height: 20px;		text-align: center;		letter-spacing: 0px;	}	.footer{		font-size:14px; 		line-height:12px;		text-align:center;		letter-spacing: 0px;}	a{		font-weight: bold;		color:#72317D;		text-decoration: none;		}	.cta{		display: inline-block;		vertical-align: middle;		text-align: center;		cursor: pointer;		text-decoration: none;		-webkit-appearance: none;		-moz-appearance: none;		appearance: none;		min-width: 220px;		min-height: 31px;padding:4px;line-height: 31px;		border: 1px solid #72317D;		color: #72317D;		text-transform: uppercase;		font-size: 15px;		font-weight: bold;		letter-spacing: 0.088em;		background-color: #fff;border-radius: 20px;}.cta:hover{background-color: #72317D;color: #fff;}</style></head><body class='body' bgcolor='#f1f1f1' style='font-family: Arial, Helvetica, sans-serif;font-size: 18px;letter-spacing: 0.5px;line-height: 30px;color: #000000;'><table width='600' border='0' align='center' cellpadding='0' cellspacing='0' bgcolor='#ffffff'><!-- HEADER IMAGE - START --><tr><td colspan='3'><a href='https://hallmarkchannelgoldrewards.com' target='_blank'><a href='https://hallmarkchannelgoldrewards.com'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/email_header.png?t=1627446526' alt='' width='600' height='250' border='0' /></a></td></tr><!-- HEADER IMAGE - END --><!-- PRIMARY COPY (H1 version) - START --><tr><td colspan='3'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/blank.gif?t=1627446526' alt='' width='20' height='20' border='0' /></td></tr><tr><td bgcolor='#ffffff' valign='top' width='60'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/blank.gif' alt='' width='60' border='0' /></td><td  valign='top' width='480'><table border=0 cellpadding=0 cellspacing=0<tr><td  valign='top' width='480' colspan='1' align='center'><table style='border-bottom: 2px solid #F5C750;'><tr><td><p class='h1' style='color:#72317D;text-align: center;'><strong><span class='h1_bold' style='font-weight: bold;'>DOWNLOAD YOUR CHRISTMAS IN JULY SPOTS NOW!</span></strong></p></td></tr></table><br></td></tr><tr><td  valign='top' width='480' colspan='1'><p class='headline' style='color:#72317D;font-weight: bold;'><br><span class='emphasis' style='font-weight: bold;color:#72317D;border-bottom: 2px solid #F5C750;'></span></p></td></tr><tr><td><p>You are one step closer to your Awarded Points! <br><br><b>Christmas in July</b> spots are now available. Download your spots <a href='https://s3.amazonaws.com/assets.hallmarkaffiliates/spots/ChristmasInJulyAllMonthLong.zip'>here</a> to get your clients ready for some Holiday Cheer, starting July 9th through July 31st! </p></td></tr><tr><td valign='top'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/0620cij.jpg?t=1627446526' alt='' width='480' border='0' /></td></tr><tr><td><p><br>&nbsp;<br></p></td></tr><tr><td align='center'><table cellpadding='0' cellspacing='0' border='0' width='480'><tr><td align='center'><a href='' class='cta' target='_blank'>&nbsp;&nbsp;DOWNLOAD SPOTS&nbsp;&nbsp;</a><br /><br /></td></tr></table></td></table></td> <td bgcolor='#ffffff' valign='top' width='60'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/blank.gif?t=1627446526' alt='' width='60'  border='0' /></td> </tr><tr><td bgcolor='#ffffff' valign='top' width='60' colspan='1'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/blank.gif?t=1627446526' alt='' width='60' border='0' /></td><td  valign='top' width='480'><table width='360' border='0' align='center' cellpadding='0' cellspacing='0' bgcolor='#ffffff' style='font-size: 16px;'><tr><td><p class='contactcopy' style='font-size: 14px;line-height: 20px;text-align: center;letter-spacing: 0px;'><br>For questions or concerns pertaining to the program, please email <a href='mailto:questions@hallmarkchannelgoldrewards.com' style='font-weight: bold;color:#72317D;text-decoration: none;' target='_blank'>questions@hallmarkchannelgoldrewards.com</a>. <br><br>For questions about Hallmark Channel, please contact your Hallmark representative.<br><br></p></td></tr></table></td><td bgcolor='#ffffff' valign='top' width='60' colspan='1'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/blank.gif?t=1627446526' alt='' width='60' border='0' /></td></tr><!-- CONTACT US - END --><!-- FOOTER - START --><tr><td bgcolor='#e1e1e1' valign='top' width='60'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/blank.gif?t=1627446526' alt='' width='60' height='80' border='0' /></td><td bgcolor='#e1e1e1' width='480'><table width='360' border='0' align='center' cellpadding='0' cellspacing='0' bgcolor='#e1e1e1'><tr><td class='footer' style='font-size:14px;line-height:12px;text-align:center;letter-spacing: 0px;' height='80'><br>&copy;2021 Hallmark Channel.<br><br><a href='https://www.hallmarkchannel.com/crown-media-family-networks-terms-of-use' style='font-weight: bold;color:#72317D;text-decoration: none;' target='_blank'>Terms of Use</a> | <a href= 'https://www.hallmarkchannel.com/privacy-policy' target='_blank' style='font-weight: bold;color:#72317D;text-decoration: none;'>Privacy Policy</a><br><br></td></tr></table></td><td bgcolor='#e1e1e1' valign='top' width='60'><img src='https://s3.amazonaws.com/assets.hallmarkaffiliates/email/blank.gif?t=1627446526' alt='' width='60' height='80' border='0' /></td></tr>	</table>	</body>	</html>";
			this.routerurl='/email-management';
			this.router.navigate(['/email-preview']);
		});
	}
	
////////////////	NOTIFICATIONS
	getNotifications(){
		var prtemp=this.processNotifications();
		console.log('adminNotificationsObj', this.adminNotificationsObj);
		return this.adminNotificationsObj;
	}
	getNotification(id){
		var prtemp=this.processNotification(id);
		console.log('adminNotificationObj', this.adminNotificationObj);
		return this.adminNotificationObj;
	}
	getNoteCTAs(){
		var prtemp=this.processNoteCTAs();
		console.log('adminCTAsObj', this.adminCTAsObj);
		return this.adminCTAsObj;
	}
	  //Angular gets the accounts for the admin
	processNotifications(){
		this.pullAdminNotifications().subscribe((response) => {
			 this.adminNotificationsObj.next(response);
			 console.log('responseNotes', response);
		});
	}
	processNotification(id){
		this.pullAdminNotification(id).subscribe((response) => {
			 var temp=response[0];
			 this.adminNotificationObj.next(temp);
		});
	}
	processNoteCTAs(){
		this.pullNoteCTAs().subscribe((response) => {
			 this.adminCTAsObj.next(response);
			 console.log('responseNotes', response);
		});
	}
	
/*
//Angular posts the form data for a preview of the email
  factory.adminGetDraftPreview = function(json_data){
    $http.post('api/previewemail',json_data).
    then( function (response){
      //console.log(response);
      if(response.status == 200){
        factory.email_draft_preview = response.data;
        $location.path('/admin/email-draft-preview'); // path not hash
        //console.log(factory.email_draft_preview);
      }
    }).catch( function(e){
      console.log("Cannot Retrieve preview emailtemplate for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }
  //Angular creates the new ad-hoc email template
  factory.adminCreateAdHocTemplate = function(){

  }

  //Angular edits the existing email template
  factory.adminEditEmailTemplate = function(template_id, reuse_template){
    $http.get('api/emailtemplate/'+ template_id).
    then( function (response){
      if(response.status == 200){
        factory.email_template_admin = response.data[0];

        //Pre-select CTA's
        if(factory.email_template_admin.enroll_now == '1'){
          factory.email_template_admin.enroll_now =true;
        }

        if(factory.email_template_admin.download_spots == '1'){
          factory.email_template_admin.download_spots =true;
        }

        if(factory.email_template_admin.shop_now == '1'){
          factory.email_template_admin.shop_now =true;
        }

        if(factory.email_template_admin.submit_results == '1'){
          factory.email_template_admin.submit_results =true;
        }

        if(factory.email_template_admin.custom_cta == '1'){
          factory.email_template_admin.custom_cta =true;
        }
        if(reuse_template == true){
          factory.email_template_admin.reuse_template = true;
        }

        $location.path('/admin/email-detail'); // path not hash
        //Loop through object and parse id's to int

        //console.log(factory.email_template_admin);
      }

    }).catch( function(e){
      console.log("Cannot Retrieve emailtemplate for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  //Angular gets the email audience
  factory.adminGetEmailAudience = function(){
    $http.get('api/usersforadmin').
    then( function (response){
      factory.audience_for_admin = response.data;
      //Loop through object and parse id's to int
      angular.forEach(factory.audience_for_admin, function(value,key){
        value.profile_id = parseInt(value.profile_id);
      });

      //console.log(factory.audience_for_admin);
    }).catch( function(e){
      console.log(e);
      console.log("Cannot Retrieve audience for Admin");

    });
  }

  //Angular saves the template updates
  factory.adminSaveEmailTemplate = function(template_id,json_data){

    $http.post('api/emailtemplate',json_data).
    then( function (response){
      if(response.status == 200){
        factory.saved_template = true;
        factory.adminEditEmailTemplate(template_id);
        console.log('Email saved!!!');
        //Loop through object and parse id's to int
      }

      //console.log(factory.email_template_admin);
    }).catch( function(e){
      console.log("Cannot Retrieve emailtemplate for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  //Angular creates the template
  factory.adminCreateEmailTemplate = function(json_data){

    $http.post('api/emailtemplate',json_data).
    then( function (response){
      if(response.status == 200){
        factory.saved_template = true;
        var template_id = response.data;
        template_id = parseInt(template_id);
        factory.adminEditEmailTemplate(template_id);
        factory.current_template_id = template_id;
        factory.create_email_template_admin = null;
        factory.new_email_template_admin = null;
        //console.log(response);
        console.log('Email saved!!!'+template_id+'here');

      }
      //console.log(factory.email_template_admin);
    }).catch( function(e){
      console.log("Cannot Retrieve emailtemplate for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  //Angular sends the test email
  factory.adminSendTestEmail = function(template_id,json_data){

    $http.put('api/sendtest',json_data).
    then( function (response){
      if(response.status == 200){
        console.log('Email sent!!!');
        //Loop through object and parse id's to int
      }
      //console.log(factory.email_template_admin);
    }).catch( function(e){
      console.log("Cannot Update emailtemplate for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  //Angular gets the preview email
  factory.adminGetSentPreview = function(template_id){
    $http.get('api/previewemail/'+ template_id).
    then( function (response){
    //console.log(response);
      if(response.status == 200){
        factory.email_sent_preview = response.data;
        //console.log(factory.email_sent_preview);
      }
    }).catch( function(e){
      console.log("Cannot Retrieve preview emailtemplate for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  //Angular posts the form data for a preview of the email
  factory.adminGetDraftPreview = function(json_data){
    $http.post('api/previewemail',json_data).
    then( function (response){
      //console.log(response);
      if(response.status == 200){
        factory.email_draft_preview = response.data;
        $location.path('/admin/email-draft-preview'); // path not hash
        //console.log(factory.email_draft_preview);
      }
    }).catch( function(e){
      console.log("Cannot Retrieve preview emailtemplate for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  factory.adminGetOffers = function(){
    $http.get('api/offers').
    then( function (response){
      //console.log(response);
      if(response.status == 200){
        factory.offers_for_admin = response.data;
        //console.log(factory.offers_for_admin);
      }

    }).catch( function(e){
      console.log("Cannot Retrieve offers for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  //Angular sends the emails to audience selected
  factory.adminSendEmails = function(template_id, json_data){
    $http.post('api/launcheblast',json_data).
    then( function (response){
      //console.log(response);
      if(response.status == 200){
        factory.email_sent_response = response.data;
        alert(factory.email_sent_response);
        $location.path('/admin/email'); // path not hash
      }
    }).catch( function(e){
      console.log("Cannot launch eblast for Admin");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

  //Admin put route for account priorities
  factory.getAccountPrioritiesAdmin = function(json_data){
    $http.put('api/accountsforadminbypriority',json_data).
    then( function (response){
      if(response.status == 200){
        console.log('Success !!!');
      }
      //console.log(factory.email_template_admin);
    }).catch( function(e){
      console.log("Cannot perform put request");
      console.log(e);
      ErrorAlertService.errorAlert()


    });
  }

*/	
	
}
